import React, { useRef } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Divider,
  InputAdornment,
  Button,
  MenuItem,
  Popover,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputTextField from "components/input/inputTextField";
import AntSwitch from "components/switch/switch";
import { getLang } from "app/feature/constants";
import LoadingComponent from "components/loading";
import InfiniteScroll from "react-infinite-scroll-component";

const useStyle = makeStyles((theme) => ({
  paper: {
    width: 418,
  },
  button: {
    padding: 0,
    minWidth: 0,
  },
  perfectScrollbar: {
    height: 200,
  },
}));

export default function InstantWinSelectPanelComponent({
  value,
  anchorEl,
  open,
  handleClose,
  isLoading,
  handleSelect,
  list,
  handleSearch,
  lang,
  handleFetchMoreItems,
  hasMore,
  isError,
  handleReload,
}) {
  const textRef = useRef();
  const classes = useStyle();

  return (
    <Popover
      id="branch-select-panel"
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      elevation={2}
      PaperProps={{
        style: { minWidth: "27em" },
      }}
    >
      <Box>
        <Box>
          <InputTextField
            variant="filled"
            inputRef={textRef}
            size="small"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ paddingRight: "6px" }}>
                  <Button
                    onClick={() => handleSearch(textRef.current.value)}
                    className={classes.button}
                  >
                    <SearchIcon fontSize="small" />
                  </Button>
                </InputAdornment>
              ),
              style: {
                backgroundColor: "white",
              },
            }}
            inputProps={{
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch(textRef.current.value);
                  return false;
                }
              },
              style: {
                padding: "14px",
              },
            }}
            placeholder={getLang(lang, "placeholder.SEARCH_INSTANT_WIN")}
          />
        </Box>
        <Divider />

        {!!isError ? (
          <Box py={1.5} px={2}>
            <Typography
              variant="body2"
              style={{ color: "#9CA6A9", paddingBottom: "16px" }}
            >
              {getLang(lang, "paragraph.SOMETHING_WENT_WRONG")}
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleReload}
              disableElevation
            >
              {getLang(lang, "label.RETRY")}
            </Button>
          </Box>
        ) : (
          <InfiniteScroll
            height="100%"
            dataLength={list.length}
            next={handleFetchMoreItems}
            hasMore={hasMore}
            loader={<LoadingComponent height={100} />}
            endMessage={
              isLoading ? (
                <LoadingComponent height={100} />
              ) : !list.length ? (
                <Box px={1.5} py={4}>
                  <Typography variant="body2" style={{ textAlign: "center" }}>
                    <b>{getLang(lang, "message.info.NO_RECORD_EXIST")}</b>
                  </Typography>
                </Box>
              ) : null
            }
          >
            {list.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  style={{
                    padding: "8px 8px",
                    backgroundColor: value?.uuid === item.uuid ? "#f5f5f5" : "",
                  }}
                  onClick={() => handleSelect(item)}
                >
                  <Box display="flex" alignItems="center">
                    <Box px={1}>
                      <AntSwitch
                        checked={
                          value.find((v) => v.uuid === item.uuid) ? true : false
                        }
                      />
                    </Box>
                    <Box>
                      <Typography variant="inherit" noWrap>
                        {item.name}
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              );
            })}
          </InfiniteScroll>
        )}
      </Box>
    </Popover>
  );
}
